
const Button = require("app/shared/components/Button/button");
const BoldText = require("app/shared/components/BoldText/bold-text");
const Icon = require("app/shared/components/Icon/icon");
const cx = require("classnames");

class Coachmark extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mounted: false,
      visible: props.visible,
      selectorProperties: this.visibleAreaDimensions()
    };

    this.windowResizeListener(props.visible);

    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  visibleAreaDimensions() {
    let selector = $(this.props.hightlightElementSelector).first();
    const elementOffset = selector.offset();
    selector.css("background-color", "white");

    return {
      top: elementOffset.top,
      left: elementOffset.left,
      width: selector.outerWidth(),
      height: selector.outerHeight()
    }
  }

  windowResizeListener(isVisible) {
    if (isVisible) {
      window.addEventListener("resize", this.handleWindowResize.bind(this));
    } else {
      window.removeEventListener("resize", this.handleWindowResize.bind(this));
    }
  }

  handleWindowResize() {
    this.setState({selectorProperties: this.visibleAreaDimensions()});
  }

  toggleVisibility() {
    const isVisible = this.state.visible;

    this.setState({visible: !isVisible})
    this.windowResizeListener(!isVisible);
  }

  tip(selectorProperties) {
    return (
      <div className="coachmark" style={{
        top: selectorProperties.top + selectorProperties.height + 8,
        left: selectorProperties.left + (selectorProperties.width / 2)
      }}>
        <div className="coachmark-arrow"></div>
        <div className="coachmark-tip">
          <h4>{this.props.title}</h4>
          <a onClick={this.toggleVisibility}>
            <Icon className="close prompt-closeButton" custom icon="close" />
          </a>
          <BoldText text={this.props.text} />
          <div className="action">
            <a className="c-pointer" onClick={this.toggleVisibility}>
              {this.props.actionText}
            </a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const coachmarkOverlayClasses = cx("coachmark-overlay", {
      "lighten": this.state.mounted
    });

    return (
      this.state.visible ?
      <div className="coachmark-container novaclassequenaoexiste">
        <div className={coachmarkOverlayClasses} style={{height: document.body.offsetHeight}} onClick={this.toggleVisibility}>
          <div className="coachmark-area" style={this.state.selectorProperties}></div>
        </div>
        {this.tip(this.state.selectorProperties)}
      </div>
      : null
    );
  }
}

Coachmark.defaultProps = {
  visible: true
};

Coachmark.propTypes = {
  hightlightElementSelector: React.PropTypes.string.isRequired,
  actionText: React.PropTypes.string.isRequired,
  title: React.PropTypes.string.isRequired,
  text: React.PropTypes.string.isRequired,
  visible: React.PropTypes.bool
};

module.exports = Coachmark;



// WEBPACK FOOTER //
// ./app/shared/components/Coachmark/coachmark.jsx